<script setup>
// "About CLD Distribution" story banner — ported from cld_homepage_mockup_v3 (#22).
// Short introduction + CTA to the /story page. The three art cards tell the story
// arc: the products we distribute → how we ship → how you buy. Swap the srcs for
// real CLD photos (warehouse / product shelf / team) whenever they're available.
const artCards = [
  { class: 'left-0 bottom-[8%] w-[52%] h-[65%] -rotate-6', src: '/story/cldg.jpg' },
  { class: 'left-[24%] top-[1%] w-[55%] h-[82%] rotate-2', src: '/story/cld-office.jpg' },
  { class: 'right-0 bottom-[4%] w-[40%] h-[64%] rotate-6', src: '/story/cldg4.jpg' },
];
</script>

<template>
  <section class="container mx-auto px-4 my-8">
    <div
      class="rounded-3xl p-8 md:p-11 text-white grid md:grid-cols-[1.15fr_.85fr] gap-8 items-center overflow-hidden shadow-lg"
      style="background: linear-gradient(120deg, var(--color-primary-700), var(--color-primary) 56%, var(--color-primary-300))"
    >
      <div>
        <p class="text-xs font-bold uppercase tracking-widest text-[#d9fff3] mb-2">{{ $t('about_cld_title') }}</p>
        <h2 class="text-3xl md:text-4xl font-semibold leading-tight m-0 text-white">{{ $t('story_banner_title') }}</h2>
        <p class="text-white/85 mt-4 mb-6 max-w-2xl">{{ $t('story_banner_text') }}</p>
        <!-- White pill + brand-green label, styled like the app's primary buttons
             (primary-700 keeps the label AA-readable on white). -->
        <NuxtLinkLocale
          to="/story"
          class="story-cta inline-flex items-center gap-2 px-6 py-2.5 rounded-lg bg-white font-semibold shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200"
        >
          {{ $t('discover_our_story') }} →
        </NuxtLinkLocale>
      </div>
      <div class="relative h-44 hidden md:block" aria-hidden="true">
        <div
          v-for="(card, i) in artCards"
          :key="i"
          class="absolute rounded-2xl border-4 border-white/75 shadow-xl overflow-hidden bg-white/20"
          :class="card.class"
        >
          <NuxtImg :src="card.src" alt="" class="w-full h-full object-cover" format="webp" width="520"
            decoding="async" />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
/* Keep the CTA white with a green label in both themes — dark.css would
   otherwise flip `bg-white` to a dark surface on this green panel. */
.story-cta {
  background-color: #fff !important;
  color: var(--color-primary-700) !important;
}
</style>
